import { render, staticRenderFns } from "./territory-list.vue?vue&type=template&id=7639d640&"
import script from "./territory-list.vue?vue&type=script&lang=js&"
export * from "./territory-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports